var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickCircleIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33464 10L9.33463 13.3334L14.668 6.66669M10.0013 19.3334C8.77563 19.3334 7.56196 19.0919 6.42959 18.6229C5.29722 18.1539 4.26832 17.4664 3.40164 16.5997C2.53496 15.733 1.84747 14.7041 1.37843 13.5717C0.909383 12.4394 0.667969 11.2257 0.667969 10C0.667969 8.77435 0.909383 7.56068 1.37843 6.42831C1.84747 5.29594 2.53496 4.26704 3.40164 3.40036C4.26832 2.53368 5.29722 1.84619 6.42959 1.37714C7.56196 0.908101 8.77563 0.666687 10.0013 0.666687C12.4767 0.666687 14.8506 1.65002 16.601 3.40036C18.3513 5.1507 19.3346 7.52467 19.3346 10C19.3346 12.4754 18.3513 14.8493 16.601 16.5997C14.8506 18.35 12.4767 19.3334 10.0013 19.3334Z",
    stroke: "white",
    strokeOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickCircleIconDark);
export default __webpack_public_path__ + "static/media/tickCircleIconDark.c7ee4893568ca217b1426e07df9ebec9.svg";
export { ForwardRef as ReactComponent };